import axios from '@/utils/axios.js'
import { encryptPassword } from '@/utils/rsa.js'
/**
 * 获取用户列表
 * @param {*} queryParams 查询参数
 * @returns 用户列表
 */
export async function getUsers(queryParams) {
  const { data } = await axios.get('/admin/user', { params: queryParams })
  return data
}

/**
 * 根据 id 查询用户
 * @param {*} userId 用户 id
 * @returns 用户
 */
export async function getUserById(userId) {
  const { data } = await axios.get(`/admin/user/${userId}`)
  return data
}

/**
 * 创建用户
 * @param {*} user 用户
 */
export async function createUser(user) {
  await axios.post('/admin/user', user)
}

/**
 * 修改用户
 * @param {*} user 用户
 */
export async function updateUser(user) {
  await axios.put('/admin/user', user)
}

/**
 * 修改密码
 * @param {*} user 用户
 */
export async function updateUserPassword(user) {
  const encryptedOldPassword = await encryptPassword(user.oldPassword)
  const encryptedNewPassword = await encryptPassword(user.newPassword)
  await axios.put('/admin/user/updatePassword', { ...user, oldPassword: encryptedOldPassword, newPassword: encryptedNewPassword })
}

/**
 * 根据 id 删除用户
 * @param {*} userIds 用户 id
 */
export async function deleteUserById(userIds) {
  await axios.delete(`/admin/user/${userIds}`)
}

/**
 * 获取登录用户信息
 * @returns 登录用户
 */
export async function getUserInfo() {
  const { data } = await axios.get('/admin/user/userInfo')
  return data
}

/**
 * 根据 id 审批用户
 * @param {*} userApprove 审批信息
 */
export async function approveUsers(userApprove) {
  await axios.post('/admin/user/approve', userApprove)
}
